<template>
  <div>
    <resource
      resource="circularMail"
      resourceName="Rundmail"
      :withFiles="true"
      :original="original"
      :createMode="true"
      :attributes="[
        {
          name: 'support_profile',
          label: 'Support-Profile',
          type: 'CheckboxSelector',
          value: false,
          hidden: rewriteMode
        },
        {
          name: 'id',
          label: 'Unbeachtete neu anschreiben für Rundmail',
          type: 'number',
          isFilter: true,
          hideEmpty: true,
          disabled: true,
          hidden: !rewriteMode
        },
        {
          name: 'sender_id',
          label: 'Absender',
          type: 'DropdownProfileSelector',
          resource: 'customerProfile',
          hidden: rewriteMode,
          hideEvent: 'support-profile',
          appends: ['primaryImage'],
          filter: [
            {
              name: 'fake'
            },
            {
              name: 'sort',
              mode: 'ASC',
              attribute: 'name'
            },
            {
              name: 'forSelect'
            },
            {
              name: 'withoutTrashed'
            },
            {
              name: 'select',
              value: ['name', 'id']
            }
          ]
        },
        {
          name: 'message_elements',
          label: 'Nachrichtenelemente',
          type: 'MessageElementsSelector'
        },
        {
          name: 'send_at',
          label: 'Versenden am',
          type: 'DateTimeSelector',
          value: null
        },

        {
          name: 'age',
          label: 'Alter',
          type: 'MultiSliderSelector',
          max: 125,
          min: 18,
          isFilter: true,
          hidden: rewriteMode
        },
        {
          name: 'send_to_gender',
          label: 'Geschlecht',
          type: 'SexSelector',
          multiSelect: true,
          isFilter: true,
          hidden: rewriteMode
        },
        {
          name: 'photo',
          label: 'Foto',
          type: 'OptionSelector',
          isFilter: true,
          hidden: rewriteMode
        },
        {
          name: 'registered_from',
          label: 'Registriert von',
          type: 'DateSelector',
          isFilter: true,
          hidden: rewriteMode
        },
        {
          name: 'registered_to',
          label: 'Registriert bis',
          type: 'DateSelector',
          isFilter: true,
          hidden: rewriteMode
        },
        {
          name: 'max_days_offline',
          label: 'Tage letzter Login',
          type: 'UserActivitySelector',
          max: circularmailOfflineDays,
          min: 0,
          isFilter: true,
          hidden: rewriteMode
        },
        {
          name: 'transaction',
          label: 'Käufe',
          type: 'OptionSelector',
          isFilter: true,
          hidden: rewriteMode
        },
        {
          name: 'spent',
          label: spendLabel,
          type: 'number',
          isFilter: true,
          hidden: rewriteMode
        }
      ]"
      @attributes-changed="updateTable"
    >
      <div slot="title">
        <h4>Rundmail erstellen</h4>
      </div>
    </resource>

    <v-table
      id="filterDetailsTable"
      v-if="showTable"
      url="/api/v1/circularMail/profile-filter-details"
      :filter="tableFilter"
      :additionalRequestData="circularMailAttributes"
      :fetchOnQueue="rewriteMode"
      :attributes="[
        {
          attribute: 'name',
          name: 'Name'
        },
        {
          attribute: 'value',
          name: 'Anzahl'
        }
      ]"
      ref="filterDetailsTable"
    >
      <div slot="title">
        Benutzeranzahl, die angeschrieben werden ({{ tableCount }})
      </div>
      <tr slot="bottom">
        <td>
          <strong>
            Gesamt
          </strong>
        </td>
        <td>
          <strong>
            {{ tableCount }}
          </strong>
        </td>
      </tr>
    </v-table>

    <v-table
      v-if="showTable"
      url="/api/v1/circularMail/filtered-profiles"
      :filter="tableFilter"
      :additionalRequestData="circularMailAttributes"
      :fetchOnQueue="rewriteMode"
      :attributes="[
        {
          attribute: 'id',
          name: 'ID'
        },
        {
          type: 'LinkProfileCell',
          name: 'Kunde'
        },
        {
          attribute: 'created_at',
          name: 'Angelegt am',
          type: 'DateCell'
        }
      ]"
      ref="table"
    >
    </v-table>
  </div>
</template>

<script lang="babel">
import moment from "moment";
import store from "@/store";

export default {
  beforeRouteEnter (to, from, next) {
    if (!to.params.id) {
      next();
    } else {
      store.dispatch('circularMail/read', [
        {
          name: 'where',
          attributes: {
            id : Number(to.params.id),
          }
        },
        {
          name: 'with',
          value: ['circularMailMessages']
        }
      ]).then(() => {
        next();
      });
    }
  },
  data() {
    return {
      moment: moment,
      tableFilter: [],
      circularMailAttributes: [],
      showTable: false,
      tableCount: 0
    };
  },
  computed: {
    circularmailOfflineDays() {
      return Laravel.settings.circularmailOfflineDays;
    },
    only_non_active_member_label() {
      return 'Nur Mitglieger die länger als '+ Laravel.settings.mail.offline_disable + ' Tage offline sind';
    },
    days_for_offline_summary() {
      return Laravel.settings.mail.offline_summary;
    },
    id() {
      return Number(this.$route.params.id);
    },
    rewriteMode() {
      return this.original ? true : false;
    },
    original() {
      if (!this.$route.params.id) {
        return null;
      }
      let originalFormData = Object.assign({}, this.$store.getters['circularMail/find'](this.id));
      originalFormData.age = {min: originalFormData.age_from, max: originalFormData.age_to};
      originalFormData.send_at = moment().add(15,'minutes').format('YYYY-MM-DD HH:mm:ss');
      originalFormData.send_to_gender = originalFormData.send_to_gender;

      if (originalFormData.max_days_offline == "[-1,-1]") {
        originalFormData.max_days_offline = true;
      } else {
        let max_days_offline = JSON.parse(originalFormData.max_days_offline)
        originalFormData.max_days_offline = {min: max_days_offline[0], max: max_days_offline[1]};
      }
      return originalFormData;
    },
    spendLabel() {
      return 'Bereits ausgegebene '+Laravel.lang.currency;
    }
  },
  methods: {
    updateTable(data) {
      this.circularMailAttributes = data;
      this.tableFilter = [];
      this.showTable = true;
      this.tableCount = 0;
      this.$nextTick(() => {
        this.$bus.$emit('refresh-table');
      });
    },
    setTableCount() {
      this.tableCount = this.$refs.table ? this.$refs.table.count : 0;
    }
  },
  created() {
    this.$bus.$on('table-fetched', this.setTableCount);
    this.$bus.$on('table-data-fetched', this.setTableCount);
    this.circularMailAttributes = this.original;
  },
  destroyed () {
    this.$bus.$off('table-fetched');
  }
}
</script>
